import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
    Container,
    Stack,
    Flex,
    Box,
    Heading,
    Text,
    Button,
    Image,
    Tabs, 
    TabList, 
    TabPanels, 
    Tab, 
    TabPanel,
    Accordion,
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    AccordionIcon, 
  } from '@chakra-ui/react';

import "./static/css/index.css";
import { ParentCard, LCard } from "./style";
import Card from '../../components/Card';

import APIConfig from "../../api/APIConfig"
import AuthService from "../../services/auth.service";

import Footer from "../../components/Footer";
import Navigation from "../../components/Navbar";

function recruitmentTime(string){
    return new Date(string).getMonth();
}

function publishDay(string){
    return new Date(string).getDate();
}

const HomePage = (props) => {
    const [lowongan, setLowongan] = useState([]);
    const [currentUser, setCurrentUser] = useState([]);
    const [showPeserta, setShowPeserta] = useState(false);
    const [showMitra, setShowMitra] = useState(false);
    const [showMentor, setShowMentor] = useState(false);
    const [showAdmin, setShowAdmin] = useState(false);

    let d = new Date().getDate();

    const getLowongan = async() => {
        const response = await APIConfig.get(`/v1/list-lowongan`);
        const result = await response.data;
        setLowongan(result);
    };

    useEffect(() => {
        const user = AuthService.getCurrentUser();
        if (user) {
            setShowPeserta(user.roles.includes("Peserta"));
            setShowMitra(user.roles.includes("Mitra"));
            setShowMentor(user.roles.includes("Mentor"));
            setShowAdmin(user.roles.includes("Admin"));
            setCurrentUser(user);
        }
    }, [])


    useEffect(() => {
        getLowongan();
    }, []);

    return (
        <>
        <Navigation/>
        <Container margin={'0'} padding={'0'} maxW={'100%'}>
            <Stack
                className="grid"
                align={'center'}
                spacing={{ base: 5, md: 10 }}
                py={{ base: 20, md: 28 }}
                direction={{ base: 'column', md: 'row' }}>
                <Stack flex={1} spacing={{ base: 5, md: 8 }}>
                    <Heading
                        fontWeight={700}
                        fontFamily={'Inter'}
                        fontSize={{ base: '3xl', sm: '4xl', lg: '4xl' }}>
                        <Text>
                            Platform <span style={{color: '#6554C0'}}>Terbaik</span> Dalam Menghubungkan Antara 
                            Perusahaan Dengan <span style={{color: '#6554C0'}}>Calon Kerja Profesional</span>
                        </Text>
                    </Heading>
                    <Text fontFamily={'Inter'}>
                        MagangPro adalah online platform yang membantu calon tenaga profesional mempercepat karirnya 
                        dengan pelatihan dan magang dalam dunia kerja nyata. Percepat Karirmu Dengan Pelatihan dan 
                        Magang Bersama MagangPro
                    </Text>
                    <Stack
                        fontFamily={'Inter'}
                        spacing={{ base: 4, sm: 6 }}
                        direction={{ base: 'column', sm: 'row' }}> 
                            <a href="#about">
                                <Button fontWeight={'normal'} style={{background: '#6554C0', color: '#FFFFFF'}}>Tentang kami</Button>
                            </a>
                        {showPeserta &&
                        <Link to="/lowongan" style={{textDecoration: 'none'}}>
                            <Button fontWeight={'normal'} style={{background: '#FFFFFF', color: '#6554C0', border: '2px solid #6554C0'}}>
                            Lihat lowongan
                            </Button>
                        </Link>
                        }
                    </Stack>
                </Stack>
                <Flex
                    flex={1}
                    justify={'center'}
                    align={'center'}
                    position={'relative'}
                    w={'full'}>
                    <Box
                        position={'relative'}
                        height={'350px'}
                        rounded={'2xl'}
                        boxShadow={'2xl'}
                        width={'full'}
                        overflow={'hidden'}>
                        <Image
                        alt={'Hero Image'}
                        fit={'cover'}
                        align={'center'}
                        w={'100%'}
                        h={'100%'}
                        src={
                            'https://images.pexels.com/photos/8062289/pexels-photo-8062289.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500'
                        }
                        />
                    </Box>
                </Flex>
            </Stack>
        </Container>


        {showPeserta && 
            <Container margin={'0'} padding={'0'} maxW={'100%'}>
            {lowongan.length > 0 ?
            <Stack className="grid2" spacing={{ base: 5, md: 10 }} fontFamily={'Inter'}>
                <Heading
                    fontWeight={700}
                    fontFamily={'Inter'}
                    fontSize={{ base: '3xl', sm: '4xl', lg: '4xl' }}>
                    <Text>
                        Lowongan Magang
                    </Text>
                </Heading>
                <ParentCard>
                    {lowongan.slice(0, 3).map((data) => (
                        <Link to={`/lowongan/detail/${currentUser.peserta[0].idPeserta}/${data.idLowongan}`} 
                            style={{color:'#000000', margin: 'auto', textDecoration: 'none'}}>
                            <Card 
                                    jabatan={data.proposal.namaPosisi}
                                    perusahaan={data.mitra.namaResmi}
                                    durasi={`${recruitmentTime(data.proposal.tanggalSelesai) - recruitmentTime(data.proposal.tanggalMulai)} bulan`}
                                    lokasi={data.proposal.lokasi}
                                    waktuPost={`${d - publishDay(data.waktuDipublish)} hari yang lalu`}
                                    logo={data.mitra.image}
                                    nominal={data.proposal.nominal}
                                />
                        </Link>
                    ))}
                </ParentCard>
                <Link to="/lowongan" style={{textDecoration: 'none', textAlign: 'center'}}>
                    <Text>Lihat semua</Text>
                </Link>
            </Stack>
            : null}
        </Container>
    }
    {!showMitra && !showMentor && !showAdmin && !showPeserta &&
            <Container margin={'0'} padding={'0'} maxW={'100%'}>
            {lowongan.length > 0 ?
            <Stack className="grid2" spacing={{ base: 5, md: 10 }} fontFamily={'Inter'}>
                <Heading
                    fontWeight={700}
                    fontFamily={'Inter'}
                    fontSize={{ base: '3xl', sm: '4xl', lg: '4xl' }}>
                    <Text>
                        Lowongan Magang
                    </Text>
                </Heading>
                <ParentCard>
                    {lowongan.slice(0, 3).map((data) => (
                        <Link to="/login" 
                            style={{color:'#000000', margin: 'auto', textDecoration: 'none'}}>
                            <Card 
                                    jabatan={data.proposal.namaPosisi}
                                    perusahaan={data.mitra.namaResmi}
                                    durasi={`${recruitmentTime(data.proposal.tanggalSelesai) - recruitmentTime(data.proposal.tanggalMulai)} bulan`}
                                    lokasi={data.proposal.lokasi}
                                    waktuPost={`${d - publishDay(data.waktuDipublish)} hari yang lalu`}
                                    logo={data.mitra.image}
                                    nominal={data.proposal.nominal}
                                />
                        </Link>
                    ))}
                </ParentCard>
                <Link to="/lowongan" style={{textDecoration: 'none', textAlign: 'center'}}>
                    <Text>Lihat semua</Text>
                </Link>
            </Stack>
            : null}
        </Container>
    }

        <Container margin={'0'} padding={'0'} maxW={'100%'}>
            <Stack className="grid2" id="about" spacing={{ base: 5, md: 10 }}>
                <Heading
                    fontWeight={700}
                    fontFamily={'Inter'}
                    fontSize={{ base: '3xl', sm: '4xl', lg: '4xl' }}>
                    <Text>
                        Tentang MagangPro
                    </Text>
                </Heading>
                <Tabs className="tabs" variant="unstyled" fontFamily={'Inter'}>
                    <TabList className="tablist">
                        <Tab className="tab" noOfLines={2}_selected={{ borderBottom: "4px solid #6554C0", color: "#6554C0" }}>
                            Apa itu MagangPro?
                        </Tab>
                        <Tab className="tab" noOfLines={2}_selected={{ borderBottom: "4px solid #6554C0", color: "#6554C0" }}>
                            Menjadi peserta dalam MagangPro?
                        </Tab>
                        <Tab className="tab" noOfLines={2}_selected={{ borderBottom: "4px solid #6554C0", color: "#6554C0" }}>
                            Buka lowongan sebagai Mitra
                        </Tab>
                        <Tab className="tab" noOfLines={2}_selected={{ borderBottom: "4px solid #6554C0", color: "#6554C0" }}>
                            Pantau aktivitas mentee sebagai Mentor
                        </Tab>
                    </TabList>

                    <TabPanels className="tabpanel">
                        <TabPanel>
                            MagangPro adalah online platform yang membantu calon tenaga profesional mempercepat karirnya 
                            dengan pelatihan dan magang dalam dunia kerja nyata. MagangPro menjadi platform bagi pengguna 
                            yang ingin mencari kegiatan magang dan mitra yang ingin mencari calon pekerja profesional sebagai 
                            anggota magang di perusahaanya. Kegiatan magang yang akan dilakukan bersifat pay internship 
                            di mana calon pekerja profesional melakukan pembayaran untuk kegiatan pelatihan dan magang 
                            yang akan dilakukan. Selam kegiatan magang tersebut, peserta akan mendapatkan bimbingan dari mentor 
                            untuk menjalankan kegiatan dan tugas yang diberikan. Selain itu, MagangPro juga memiliki 
                            sistem verifkasi dalam menjamin kualitas dari mitra perusahaan yang menyediakan lowongan magang.
                        </TabPanel>
                        <TabPanel>
                            Peserta dalam MagangPro merupakan calon pekerja profesional yang terdiri dari setiap kalangan yang 
                            ingin mengasah skill mereka dalam dunia kerja profesional. Dengan MagangPro, calon tenaga profesional 
                            (peserta) mendapatkan pelatihan terkait posisi yang dipilih. Setelah pelatihan, peserta dapat merasakan 
                            bekerja magang diperusahaan top. Berpotensi mendapatkan portofolio yang mumpuni.
                        </TabPanel>
                        <TabPanel>
                            Bagi perusahaan mitra tempat magang, mitra berkesempatan mendapatkan calon kandidat karyawan yang tepat, 
                            mengurangi biaya internship, dan menjadikan magang menjadi program CSR untuk pendidikan.
                        </TabPanel>
                        <TabPanel>
                            Selama kegiatan magang, mitra akan meyediakan mentor sebagai pembimbing peserta sehingga dapat menghasilkan 
                            output yang maksimala dalam mengerjakan tugas yang diberikan.
                        </TabPanel>
                    </TabPanels>
                </Tabs>
            </Stack>
        </Container>
        <Container margin={'0'} padding={'0'} maxW={'100%'}>
            <Stack className="grid2" spacing={{ base: 5, md: 10 }} background={'#6554C0'} color={'#FFFFFF'} textAlign={'center'}>
                <Heading
                    fontWeight={700}
                    fontFamily={'Inter'}
                    fontSize={{ base: '3xl', sm: '4xl', lg: '4xl' }}>
                    <Text>
                        Manfaat MagangPro untuk Pengguna
                    </Text>
                </Heading>
                <Text fontFamily={'Inter'}>
                    Berikut ini manfaat yang akan didapatkan bagi setiap pengguna platform MagangPro:
                </Text>
                <br></br>
                <ParentCard>
                    <LCard>
                        <Text>Peningkatan skills bagi peserta</Text>
                    </LCard>
                    <LCard>
                        <Text>Peserta memiliki kesempatan bekerja di perusahaan</Text>
                    </LCard>
                    <LCard>
                        <Text>Mendapatkan portofolio dari proyek nyata bagi peserta</Text>
                    </LCard>
                    <LCard>
                        <Text>Mentor yang ahli dibidangnya bagi mitra</Text>
                    </LCard>
                    <LCard>
                        <Text>Calon kandidat karyawan yang tepat bagi mitra</Text>
                    </LCard>
                    <LCard>
                        <Text>Program CSR untuk pendidikan bagi mitra</Text>
                    </LCard>
                </ParentCard>
            </Stack>
        </Container>

        <Container margin={'0'} padding={'0'} maxW={'100%'}>
            <Stack className="grid2" spacing={{ base: 5, md: 10 }}>
                <Heading
                    textAlign={'center'}
                    fontWeight={700}
                    fontFamily={'Inter'}
                    fontSize={{ base: '3xl', sm: '4xl', lg: '4xl' }}>
                    <Text>
                        FAQ
                    </Text>
                </Heading>
                <Accordion allowToggle fontFamily={'Inter'}>
                    <AccordionItem p={2}>
                        <h2>
                        <AccordionButton>
                            <Box flex='1' textAlign='left' fontWeight={500}>
                                Berapa lama mengikuti pelatihan dan magang?
                            </Box>
                            <AccordionIcon />
                        </AccordionButton>
                        </h2>
                        <AccordionPanel pb={2} margin={'5px'}>
                            Durasi pelatihan selama 1-2 bulan, sedangkan untuk magang disesuaikan dengan perusahaan mitra
                        </AccordionPanel>
                    </AccordionItem>

                    
                    <AccordionItem p={2}>
                        <h2>
                        <AccordionButton>
                            <Box flex='1' textAlign='left' fontWeight={500}>
                                Berapa Biaya mengikuti pelatihan dan magang di MagangPro?
                            </Box>
                            <AccordionIcon />
                        </AccordionButton>
                        </h2>
                        <AccordionPanel pb={2} margin={'5px'}>
                            Biaya pelatihan dan magang disesuaikan dengan posisi magang perusahaan mitra
                        </AccordionPanel>
                    </AccordionItem>

                    
                    <AccordionItem p={2}>
                        <h2>
                        <AccordionButton>
                            <Box flex='1' textAlign='left' fontWeight={500}>
                                Apa yang peserta dapatkan jika sudah lulus pelatihan dan magang?
                            </Box>
                            <AccordionIcon />
                        </AccordionButton>
                        </h2>
                        <AccordionPanel pb={2} margin={'5px'}>
                            Peserta memiliki skill pada posisi magang yang diikuti, memiliki portofolio nyata yang real, 
                            bukan study case, sertifikat, dan belajar entrepreneurship serta berkesempatan langsung menjadi 
                            karyawan di perusahaan tempat magang.
                        </AccordionPanel>
                    </AccordionItem>
                </Accordion>
            </Stack>
        </Container>
        <Footer/>
        </>
    );
}

export default HomePage;